import React from 'react';
import Payout from './Payout';
import {LoadIndicator} from '../../components';
import {withPageLayout, WithPageLayoutProps} from '../../hocs';
import {useSelector} from 'react-redux';
import {selectPayoutReport} from '../../selectors';

export type PayoutViewProps = WithPageLayoutProps;

const PayoutView: React.FC<PayoutViewProps> = props => {
    const reportState = useSelector(selectPayoutReport);

    return (
        <LoadIndicator isLoading={false} messages={props.messages}>
            <Payout reportState={reportState} {...props} />
        </LoadIndicator>
    );
};

export default withPageLayout(PayoutView);
